import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  DetailEntry,
  EntryItem,
  Gallery,
  GenericContent
} from '@com-delta-omnichannel/aura';

export interface EducationalItem {
  detail: string;
  entry: EntryItem;
  tierMiles?: DetailEntry[];
  action?: Link;
}

export interface EducationalSection {
  header: GenericLabel;
  items: EducationalItem[];
  action: Link;
  note?: string;
}

export interface Introduction {
  header: Pick<GenericContent, 'title' | 'content'>;
  requirements: Gallery;
  note: string;
}

export interface EducationalContent extends DisplayProperties {
  title: string;
  introduction: Introduction;
  sections: EducationalSection[];
}
